import React, { useState } from 'react';

function getModSession() {
  try { return JSON.parse(localStorage.getItem('avalon_mod_session')); } catch (e) { return null; }
}

export default function JoinScreen({ onCreateGame, onJoinGame, onRejoinModerator, error, setError, autoReconnecting }) {
  const [mode, setMode] = useState(null); // null | 'join'

  // Pre-fill room code from saved session
  const savedSession = (() => {
    try { return JSON.parse(localStorage.getItem('avalon_session')); } catch (e) { return null; }
  })();
  const [roomCode, setRoomCode] = useState(savedSession?.roomCode || '');
  const [playerName, setPlayerName] = useState(savedSession?.playerName || '');

  if (autoReconnecting) {
    return (
      <div className="join-screen">
        <div className="game-title">AVALON</div>
        <div className="subtitle">The Resistance</div>
        <div className="waiting-state">
          <div className="waiting-icon">{'\u231B'}</div>
          Reconnecting to your game...
        </div>
      </div>
    );
  }

  const handleJoin = (e) => {
    e.preventDefault();
    const code = roomCode.trim().toUpperCase();
    const name = playerName.trim();
    if (!code || code.length < 4) {
      setError('Enter a valid room code');
      return;
    }
    if (!name || name.length < 1) {
      setError('Enter your display name');
      return;
    }
    if (name.length > 20) {
      setError('Name must be 20 characters or fewer');
      return;
    }
    onJoinGame(code, name);
  };

  if (mode === 'join') {
    return (
      <div className="join-screen">
        <div className="game-title">AVALON</div>
        <div className="subtitle">The Resistance</div>

        <form className="join-form" onSubmit={handleJoin}>
          <input
            type="text"
            className="room-code-input"
            placeholder="ROOM CODE"
            value={roomCode}
            onChange={(e) => {
              setRoomCode(e.target.value.toUpperCase().slice(0, 6));
              setError('');
            }}
            maxLength={6}
            autoComplete="off"
            autoFocus
          />
          <input
            type="text"
            placeholder="Your display name"
            value={playerName}
            onChange={(e) => {
              setPlayerName(e.target.value);
              setError('');
            }}
            maxLength={20}
            autoComplete="off"
          />
          {error && <div className="error-msg">{error}</div>}
          <button type="submit" className="btn btn-gold btn-full">
            Join Game
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-full"
            onClick={() => { setMode(null); setError(''); }}
          >
            Back
          </button>
        </form>
      </div>
    );
  }

  const modSession = getModSession();

  return (
    <div className="join-screen">
      <div className="game-title">AVALON</div>
      <div className="subtitle">The Resistance</div>

      {error && <div className="error-msg">{error}</div>}

      <div className="join-options">
        <button className="btn btn-gold btn-full" onClick={onCreateGame}>
          Create Game (Moderator)
        </button>
        <button
          className="btn btn-secondary btn-full"
          onClick={() => { setMode('join'); setError(''); }}
        >
          Join Game (Player)
        </button>
        {modSession?.modSessionToken && modSession?.roomCode && (
          <button
            className="btn btn-secondary btn-full"
            onClick={() => { setError(''); onRejoinModerator(); }}
          >
            Rejoin as Moderator ({modSession.roomCode})
          </button>
        )}
      </div>
    </div>
  );
}
